module.exports = __webpack_public_path__ + "img/cass6.b0853883.jpg";